const kilobyte = 1024;

export function formatNumberToFixed(amount: number | undefined): string {
	const total = amount ?? 0;
	return total.toFixed(Number.isInteger(total) ? 0 : 2);
}

export const getPercentage = (value: number, total: number) => {
	if (value === 0 && total === 0) return 0;
	return Math.round((value / total) * 1000) / 10;
};

export function formatFileSize(fileSizeInBytes: number) {
	if (fileSizeInBytes < kilobyte) {
		return fileSizeInBytes + ' Bytes';
	} else if (fileSizeInBytes < kilobyte * kilobyte) {
		return (fileSizeInBytes / kilobyte).toFixed(2) + ' KB';
	} else {
		return (fileSizeInBytes / (kilobyte * kilobyte)).toFixed(2) + ' MB';
	}
}

/**
 * Rounds a number to a specified number of decimal places.
 * @param number - Number to round
 * @param precision - Decimal places required
 * @returns
 */
export function roundNumber<T extends number>(number: T, precision: number = 0) {
	const factor = Math.pow(10, precision);
	return (Math.round(number * factor) / factor) as T;
}

/**
 * Formats a given amount into a currency string based on the specified currency.
 *
 * @param amount - The base amount in the smallest currency unit (e.g., cents).
 * @param currency - The currency code, defaulting to Australian Dollar (AUD).
 * @returns  - A formatted currency string localized to en-AU (e.g., "$1,234.00").
 */
export function formatCurrencyDisplay(amount: number, currency: string = 'AUD'): string {
	const safeAmount = typeof amount === 'number' ? amount : 0;
	return safeAmount.toLocaleString('en-AU', {
		style: 'currency',
		currency,
		maximumFractionDigits: 2,
		minimumFractionDigits: 0
	});
}
